import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '../buttons';

const footer = (props) => {
    let buttonView;
    if (props.buttons) {
        if (props.type === 'yesno') {
            buttonView = (
                <Modal.Footer style={props.footerStyle} className={props.footerClassName}>
                    {
                        props.otherButtonComponents
                    }
                    {
                        props.lbText ?
                        <Button
                            className="btn-secondary btn-sm"
                            onClick={props.lbClick}>
                            { props.lbText }
                        </Button> : ''
                    }
                    {
                        props.rbText ?
                        <Button
                            className={`btn-primary btn-sm justify-content-end ${props.rbClassName}`}
                            loading={props.loading}
                            onClick={props.rbClick}>
                            { props.rbText }
                        </Button> : ''
                    }
                </Modal.Footer>
            );
        } else if (props.type === 'oneButton') {
            buttonView = (
                <Modal.Footer style={props.footerStyle} className={props.footerClassName}>
                    <Button
                        className="btn-primary btn btn-block"
                        loading={props.loading}
                        onClick={props.bClick}>
                        { props.bText }
                    </Button>
                </Modal.Footer>
            );
        } else if (props.type === 'custom') {
            buttonView = props.footerComponent;
        }
    } else {
        buttonView = null
    }
    return buttonView;
};

const header = (props) => {
    if (props.removeHeader) {
        return null
    }

    return (
        <Modal.Header className={props.headerClassName} closeButton>
            <h5>{props.title}</h5>
        </Modal.Header>
    )
}

const CustomModal = (props) => (
    <Modal
        size={props.size}
        show={props.show}
        onHide={props.onHide}
        dialogClassName={props.dialogClassName}
    >
        { header (props) }
        <Modal.Body className={props.bodyClassName}>
            { props.children }
        </Modal.Body>
        { footer(props) }
    </Modal>
);

export default CustomModal;
